import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonAction } from "../../../../../../core/types/button-action.types";
import { FileCard } from "../../../../../../core/types/file-card.types";
import { defaultFileCard, defaultImgSize } from "../../configs/file-card-config";
import { smoothShowHideHeight } from "../../../../../animations/smoothShowHideAnimations";
import { ImgSize } from "../../types/file-card.types";
import { FileCardImageComponent } from "../file-card-image/file-card-image.component";
import { FormatSizePipe } from "../../../../../pipes/format-size.pipe";
import { MatMiniFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { FileProgressBarStatusComponent } from "../../../file-progress-bar-status/file-progress-bar-status.component";

@Component({
  selector: 'div[app-card-variant-first]',
  standalone: true,
  imports: [
    FileCardImageComponent,
    FormatSizePipe,
    MatMiniFabButton,
    MatIcon,
    MatTooltip,
    FileProgressBarStatusComponent
  ],
  templateUrl: './card-variant-first.component.html',
  styleUrl: './card-variant-first.component.scss',
  animations: [ smoothShowHideHeight ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardVariantFirstComponent {
  fileCard = input<FileCard>(defaultFileCard);
  imgSize = input<ImgSize>(defaultImgSize);
  isNeedPreview = input<boolean>(false);
  infoTooltip = input<string>('');
  isAction = input<boolean>(false);
  isImage = input<boolean>(false);
  handleBtnClick = output<ButtonAction>();

  public handleClick(buttonAction: ButtonAction): void {
    this.handleBtnClick.emit(buttonAction);
  }
}
